import React from 'react';
import { useSelector } from 'react-redux';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { reportSelector } from '../../redux/modules/report/report.selectors';
import { CashTable } from './CashTable';
import { SystemCashWidget } from './SystemCashWidget';
import { SystemLiveWidget } from './SystemLiveWidget';

export function CashTab() {
  const { error } = useSelector(reportSelector);

  return (
    <>
      {error && <Alert severity="error">{error.message}</Alert>}
      <Grid item container flexDirection="column" component={Paper} sx={{ p: '24px', mt: 0 }}>
        <Grid item container sx={{ mb: 4 }}>
          <Typography variant="h6">Live Balance</Typography>
          <SystemLiveWidget />
        </Grid>

        <Divider variant="inset" />

        <SystemCashWidget />
      </Grid>

      <Grid item container flexDirection="column" component={Paper} sx={{ p: '24px', mt: 6 }}>
        <Grid item container>
          <Typography variant="h6">Cash Report</Typography>
          <CashTable />
        </Grid>
      </Grid>
    </>
  );
}
